import { ButtonContainer } from '@/components/global';
import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTrace, useAirKeyTracePageView } from '@/utils/airKeyTrace';
import { cn } from '@/utils/cn';
import { Button } from '@cof/omni-react';

export const RetryVerification = ({ onAccept }: { onAccept: () => void }) => {
  useAirKeyTracePageView('retry_verification_modal');
  const sendTrace = useAirKeyTrace();
  const { content, locale } = useConfig();

  const handleRetry = () => {
    sendTrace({ view: 'retry_verification_modal', action: 'retry' });
    onAccept(); // Fires existing callback from templates
  };

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.retry.img.src}`}
      iconSize={content.retry.img.width}
      title={content.retry.title[locale]}
      titleSize={19}
      body={content.retry.description[locale]}
      isButtonAtBottom
      button={
        <ButtonContainer>
          <Button
            size="medium"
            className={cn(
              'text-neutral-inverse',
              'bg-interactive-emphasis-high',
            )}
            onClick={handleRetry}
          >
            Try again
          </Button>
        </ButtonContainer>
      }
    />
  );
};
